export default "__VITE_ASSET__c4af9013__"